module.exports = __webpack_public_path__ + "img/JIANHANG.d8c5a2a8.png";